import { useEffect, useRef, useState } from "react";
import { useReception } from "../ReceptionContext";

// Compact dropdown showing the customer's currently-selected reception.
// Lives in the Navbar (both desktop and mobile collapse). Persists choice
// via ReceptionContext / localStorage so subsequent form submissions tag
// the right `center`.
export const ReceptionPicker = ({ variant = 'desktop' }) => {
    const { receptions, selected, setSelected, loading } = useReception();
    const [open, setOpen] = useState(false);
    const wrapperRef = useRef(null);

    useEffect(() => {
        const close = (e) => {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', close);
        return () => document.removeEventListener('mousedown', close);
    }, []);

    if (loading || receptions.length === 0) return null;
    // Single reception → nothing meaningful to switch between; hide the picker.
    if (receptions.length === 1) return null;

    const label = selected?.name || 'Reception';
    const widthClass = variant === 'mobile' ? 'w-60' : 'w-44 md:w-52';

    return (
        <div ref={wrapperRef} className={`relative ${widthClass}`}>
            <button
                type="button"
                onClick={() => setOpen((o) => !o)}
                className="w-full flex items-center justify-between gap-2 px-3 py-2 rounded border border-gray-600 text-white text-sm hover:bg-gray-800 transition-colors"
            >
                <span className="flex items-center gap-2 truncate">
                    <svg className="w-4 h-4 text-primaryBlue flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M3 21h18M5 21V7l7-4 7 4v14M9 9h.01M9 12h.01M9 15h.01M9 18h.01M15 9h.01M15 12h.01M15 15h.01M15 18h.01" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <span className="truncate">{label}</span>
                </span>
                <svg className={`w-4 h-4 transition-transform ${open ? 'rotate-180' : ''}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M6 9l6 6 6-6" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </button>
            {open && (
                <div className="absolute left-0 right-0 mt-1 bg-white text-gray-900 border border-gray-200 rounded-lg shadow-lg z-50 max-h-72 overflow-y-auto">
                    {receptions.map((r) => (
                        <button
                            key={r._id}
                            type="button"
                            onClick={() => { setSelected(r); setOpen(false); }}
                            className={`w-full text-left px-3 py-2 text-sm hover:bg-blue-50
                                ${selected?._id === r._id ? 'bg-blue-50 text-blue-700 font-medium' : ''}
                            `}
                        >
                            <div>{r.name}</div>
                            {r.address && <div className="text-xs text-gray-500">{r.address}</div>}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default ReceptionPicker;
